//@flow

import {fetchClearanceProductPrices} from "./fetchClearanceProducts";
import type {ClearancePrice} from "./clearanceTypes";

const getPriceOnQuantity = (price: number, quantity: number) : string =>
    (price * quantity).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });

function getClearanceNewPack1IncGSTPrice(clearancePrice: ?ClearancePrice){

    return clearancePrice
        && clearancePrice.newPrice
        && clearancePrice.newPrice.pack1
        && clearancePrice.newPrice.pack1.priceIncGST || 0;
}

function getClearanceOldPack1IncGSTPrice(clearancePrice: ?ClearancePrice){
    return clearancePrice
        && clearancePrice.oldPrice
        && clearancePrice.oldPrice.pack1
        && clearancePrice.oldPrice.pack1.priceIncGST || 0;
}


function updateClearanceOldPack1IncGSTPrice(productTiles:HTMLElement[], clearanceProductPrices:{ [productId: number]: ClearancePrice}) {
    const clearanceProductsCodes:number[] = Object.keys(clearanceProductPrices).map(productCode => parseFloat(productCode));
    const clearanceProductTiles:HTMLElement[] = productTiles.filter(productTile => clearanceProductsCodes.includes(parseFloat(productTile.dataset.productCode)));
    clearanceProductTiles.map(productTile => {
        const cmpPack1GstInclusivePrice = productTile.getAttribute("data-pack1-cmp-inc-gst");
        const productId = productTile.dataset.productCode;
        const clearancePrice:?ClearancePrice = clearanceProductPrices[parseFloat(productId)];
        const clearanceNewPack1IncGSTPrice = getClearanceNewPack1IncGSTPrice(clearancePrice);
        if (clearanceNewPack1IncGSTPrice === parseFloat(cmpPack1GstInclusivePrice)) {
            const clearanceOldPack1IncGSTPrice = getClearanceOldPack1IncGSTPrice(clearancePrice);
            if (clearanceOldPack1IncGSTPrice > clearanceNewPack1IncGSTPrice) {
                const  clearancePriceDivElement:?HTMLElement = productTile.querySelector('.product-tile__price--clearance');
                const clearancePriceElement = clearancePriceDivElement && clearancePriceDivElement.querySelector('.product-tile__price-val')
                if (clearancePriceDivElement && clearancePriceElement) {
                    clearancePriceElement.innerText = getPriceOnQuantity(clearanceOldPack1IncGSTPrice, 1);
                    clearancePriceDivElement.classList.remove("hidden");
                }

            }
        }
    })
}

function displayClearanceProductPriceBlocks (productTiles:HTMLElement[]){
    productTiles.forEach(productTile =>{
        const  cmpPriceElement:?HTMLElement = productTile.querySelector('.product-tile__price--cmp');
        const  clearancePriceElement:?HTMLElement = productTile.querySelector('.product-tile__price--clearance');
        if (!clearancePriceElement){
            const clearancePriceDivElement = document.createElement('div');
            clearancePriceDivElement.classList.add('product-tile__price');
            clearancePriceDivElement.classList.add('product-tile__price--clearance');
            clearancePriceDivElement.classList.add('hidden');

            const pricePrefixSpanElement = document.createElement('span');
            pricePrefixSpanElement.classList.add('product-tile__price-prefx');
            pricePrefixSpanElement.innerText = 'CMP';
            clearancePriceDivElement.appendChild(pricePrefixSpanElement);

            const priceAmountSpanElement = document.createElement('span');
            priceAmountSpanElement.classList.add('product-tile__price-val');
            priceAmountSpanElement.innerText = '$0.00';
            clearancePriceDivElement.appendChild(priceAmountSpanElement);

            const priceSuffixSpanElement = document.createElement('span');
            priceSuffixSpanElement.classList.add('product-tile__price-suffx');
            priceSuffixSpanElement.innerText = '(inc.gst)';
            clearancePriceDivElement.appendChild(priceSuffixSpanElement);

            if (cmpPriceElement) {
                if (cmpPriceElement.nextSibling)  {
                    cmpPriceElement.parentNode && cmpPriceElement.parentNode.insertBefore(clearancePriceDivElement, cmpPriceElement.nextSibling);
                } else {
                    cmpPriceElement.parentNode && cmpPriceElement.parentNode.appendChild(clearancePriceDivElement);
                }
            }
        }
    });
}

export default async function initClearancePrices(win: WindowProxy) {
    const productTiles: HTMLElement[] = [...win.document.querySelectorAll(`.product-tile`)];
    const productCodes: number[] = productTiles.map((productTile: HTMLElement) => parseFloat(productTile.dataset.productCode));
    const wrapper = win.document.querySelector(`.product-search-page-body-wrapper`);
    const userType = wrapper ? wrapper.getAttribute('data-user-type') : null;
    if (userType !== 'MAX_USER') {
        try {
            const clearanceProductPrices: { [productId: number]: ClearancePrice } = await fetchClearanceProductPrices(productCodes);
            if (clearanceProductPrices && Object.keys(clearanceProductPrices).length > 0) {
                displayClearanceProductPriceBlocks(productTiles);
                updateClearanceOldPack1IncGSTPrice(productTiles, clearanceProductPrices)
            }
        } catch (err) {
            console.error('clearance fetch failed ' + err);
        }
    }
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/clearance/clearancePrice.js